import { render, staticRenderFns } from "./EditSfuConfigForm.vue?vue&type=template&id=41be87e2&scoped=true&"
import script from "./EditSfuConfigForm.vue?vue&type=script&lang=js&"
export * from "./EditSfuConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./EditSfuConfigForm.vue?vue&type=style&index=0&id=41be87e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be87e2",
  null
  
)

export default component.exports